module.exports={turnstile_modal:{message:"セキュリティ手続き進行中"}};